<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/authoring_list']"><img src="assets/images/admin/backarrow.png" /> Back to Content Authoring</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap ">
    <div class="formHeading">
        <h2>Create Content Capsule</h2>
    </div>
    <div class="formArea">
 <div class="dynamicBookWrap">
    <div class="container">
        <div class="row">
            <div class="resultWrap pt-3">
                <div class="resul_img">
                    <img src="assets/images/illus.png" />
                </div>
                 <h4>You have successfully created a new content capsule!</h4>
                 <span class="divider"></span>
                 <h4><a href="javascript:void(0);" class="btn-link" [routerLink]="['/authoring_view']" [queryParams]="{id: contentDetailsData?.content_capsule_id}" >{{contentDetailsData?.capsule_name}} </a>
                 
                 <ul class="modifyIcons" style="margin-left: 40%;" *ngIf="contentDetailsData">
                    <li *ngIf="contentDetailsData?.assessment_id && contentDetailsData.assessment_id!=null && contentDetailsData.assessment_id!=''"><a href="javascript:void(0);"><img src="assets/images/icons/frame.svg"></a></li>
                    <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'1')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/text.svg"></a></li>
                    <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'2')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg"></a></li>
                    <li *ngIf="(contentDetailsData?.contentCapsuleMedia) && (getMediaType(contentDetailsData.contentCapsuleMedia,'3')==true)"><a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg"></a></li>
                </ul></h4>
                 <a href="javascript:void(0);"   [routerLink]="['/authoring_list']" class="backPage ml-2 mr-2">Go back to Content Authoring</a>
                 <a href="javascript:void(0);" [routerLink]="['/authoring_view']" [queryParams]="{id: contentDetailsData?.content_capsule_id}" class="btn btn-primary download ml-2 mr-2">View Content Capsule</a>
                 <div class="illusBtnWrap">
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>
</div>